import ArrayEditor from './array'
import AssetEditor from './asset'
import CheckboxEditor from './checkbox'
import ChoicesEditor from './choices'
import DatasetEditor from './dataset'
import LargeArrayEditor from './large-array'
import MultipleEditor from './multiple'
import ObjectEditor from './object'
import SelectEditor from './select'
import TableEditor from './table'
import TagsEditor from './tags'
import EnumSourceHelperEditor from './enum-source-helper'
import NestedArrayEnumSourceHelper from './nested-array-enum-source-helper'
import CSVArrayEditor from './csv-array'
import Header from './header'
import TypeSelectorEditor from './type-selector'
import UUIDEditor from './uuid'

export default {
  array: ArrayEditor,
  asset: AssetEditor,
  checkbox: CheckboxEditor,
  choices: ChoicesEditor,
  dataset: DatasetEditor,
  largeArray: LargeArrayEditor,
  multiple: MultipleEditor,
  object: ObjectEditor,
  select: SelectEditor,
  table: TableEditor,
  tags: TagsEditor,
  enumSourceHelper: EnumSourceHelperEditor,
  nestedArrayEnumSourceHelper: NestedArrayEnumSourceHelper,
  csvArray: CSVArrayEditor,
  header: Header,
  typeSelector: TypeSelectorEditor,
  uuid: UUIDEditor
}
